// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import iView from 'iview'
import Api from './utils/api'
import Path from './utils/path'
import * as Events from './utils/events'

import './assets/css/basic.css'
import 'iview/dist/styles/iview.css'
import './assets/css/font-awesome.min.css'

import ProjectCore from 'ly-report-link'
Vue.prototype.$api = Api
Vue.prototype.$path = Path
Vue.prototype.$events = Events

// 事件广播对象
Vue.prototype.$eventHub = Vue.prototype.$eventHub || new Vue()
// 阻止 vue 在启动时生成生产提示。
Vue.config.productionTip = false

Vue.use(iView)
Vue.use(ProjectCore)

// 全局路由钩子
router.beforeEach(Path.globalRouterBeforeEach)
/* eslint-disable no-new */
new Vue({
	el: '#app',
	store,
	router,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js